export const FORM_FIELD = {
  PINCODE: "pinCode",
  HOUSE: "house",
  AREA: "area",
  NAME: "name",
  PHONE: "phone",
  EMAIL: "email",
  COUNTRY: "country",
};

export const FORM_FIELD_PLACEHOLDER = {
  NAME: "Add receiver’s name",
  PHONE: "Enter a 10-digit number",
  EMAIL: "Enter email address",
  PINCODE: "Enter a 6-digit pincode",
  COUNTRY: "Enter country",
  HOUSE: "E.g. 11-A Tower",
  AREA: "E.g. MG Road",
};

export const ADDRESS_TYPE = {
  ADD: "ADD_ADDRESS",
  EDIT: "EDIT_ADDRESS",
};

export const ADDRESS_URL_TYPE = {
  EDIT: "/edit",
  ADD: "/add",
};

export const DEFAULT_MESSAGE = {
  HEADER_TITLE: "Select Address",
  HEADER_SIGN_UP_TITLE: "Sign up",
  HEADER_ADDRESS_TITLE: "Address",
  HEADER_PAYMENT_TITLE: "Payment",
  PAGE_TITLE: "Choose Address",
  PAGE_SUBTITLE: "Detailed address will help our delivery partner reach your doorstep quickly",
  ADD_NEW_ADDRESS: "Add New Address",
  DEFAULT: "Default",
  EDIT: "Edit",
  SHIP_TO_THIS_ADDRESS: "Ship to this Address",
  FOOTER_1: "Buy Authentic Products. Pay Securely.",
  FOOTER_2: "Easy Returns and Exchange",
};

export const NEW_ADDRESS_DEFAULT_MESSAGE = {
  AUTO_DETECT: "Auto Detect",
  ADDRESS: "Address",
  PINCODE: "Pincode",
  HOUSE_LABEL: "House/ Flat/ Office No.",
  AREA_LABEL: "Road Name/ Area /Colony",
  CITY: "City",
  STATE: "State",
  CONTACT: "Contact",
  NAME: "Name",
  PHONE: "Phone",
  PHONE_NUMBER: "Phone Number",
  EMAIL: "Email ID",
  OPTIONAL_EMAIL: "Email ID (Optional)",
  PRIVACY_NOTE: "Don’t worry! We believe in sharing you offers, not your data.",
  PRIVACY_NOTE_NEW: "Your data is stored securely and shared only for the purpose of delivery.",
  BOTTOM_SHEET_TITLE: "Changes not saved",
  BOTTOM_SHEET_CONTENT: "By going back you'll lose all edits you made. Do you want to save or go back?",
  USE_AS_DEFAULT_ADDRESS: "Use as default Address",
  BOTTOM_SHEET_CANCEL: "Don't Save",
  BOTTOM_SHEET_SUCCESS: "Save Changes",
  AUTO_DETECT_BOTTOMSHEET_TITLE: "Update Area or Colony?",
  EDIT: "Edit",
  CONFIRM: "Confirm",
  LOCATION_AUTO_DETECTED: "Location auto-detected",
  ENTER_PINCODE: "Enter your pincode below",
  WE_DETECT_LOCATION: "We’ll detect your city and state",
  SAVED_AS_PRIMARY_ADDRESS: "This will be saved as your primary address.",
  USE_AS_PRIMARY_ADDRESS: "Use as primary address",
  NEW_AUTO_DETECT_BOTTOM_SHEET_TITLE: "What’s your address?",
  NEW_AUTO_DETECT_BOTTOM_SHEET_SUB_TITLE: "Allow us to detect your current location, or add manually if you’re ordering elsewhere.",
  ADD_MANUALLY_BTN: "Add manually",
  DETECT_LOCATION_BTN: "Detect location",
  USE_CURRENT_LOCATION: "Use current location",
  ACCURATE_DELIVERY: "For accurate delivery",
  LOCATION_PERMISSION_TEXT: "Go to settings and enable location permission to use the auto-detect feature.",
  IMPORT_ADDRESS_BOTTOM_SHEET_TITLE: "Add your address",
  IMPORT_ADDRESS_BOTTOM_SHEET_SUB_TITLE: "Get your saved address from Nykaa Beauty or add manually",
  IMPORT_BUTTON_TEXT: "Import"
};
